import ExternalSettingsRepository from '../../domain/repositories/ExternalSettingsRepository';
import ExternalSettingsDataStore from '../datastores/ExternalSettingsDataStore';
import ExternalSettingsDataStoreFactory from '../factories/ExternalSettingsDataStoreFactory';

export default class ExternalSettingsDataRepository
  implements ExternalSettingsRepository
{
  getStudentPortalSettings() {
    const externalSettings: ExternalSettingsDataStore =
      ExternalSettingsDataStoreFactory.create();
    return externalSettings.getStudentPortalSettings();
  }

  getBannerList() {
    const externalSettings: ExternalSettingsDataStore =
      ExternalSettingsDataStoreFactory.create();
    return externalSettings.getBannerList();
  }

  getBannerDetail(bannerId: number) {
    const externalSettings: ExternalSettingsDataStore =
      ExternalSettingsDataStoreFactory.create();
    return externalSettings.getBannerDetail(bannerId);
  }

  getLinksInterest() {
    const externalSettings: ExternalSettingsDataStore =
      ExternalSettingsDataStoreFactory.create();
    return externalSettings.getLinksInterest();
  }

  getVersion() {
    const externalSettings: ExternalSettingsDataStore =
      ExternalSettingsDataStoreFactory.create();
    return externalSettings.getVersion();
  }
}
